export enum CambioEstadoCivilEnum {
  DE_UNION_LIBRE_A_CASADO = 1,
  DE_SOLTERO_SEPARADO_O_VIUDO_A_CASADO = 2,
  DE_SOLTERO_SEPARADO_O_VIUDO_A_UNION_LIBRE = 3,
  DE_CASADO_O_UNION_LIBRE_A_SEPARADO = 4,
  DE_CASADO_O_UNION_LIBRE_A_VIUDO = 5
}
